import React, { useState } from "react";

import { FormattedMessage } from "gatsby-plugin-react-intl";
import PropTypes from "prop-types";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import useMediaQuery from "../../hooks/haiku/useMediaQuery";
import { ReactComponent as IconAccordionExpand18 } from "../../icons/icon/18/a-icon-accordeon-expand-18.svg";
import { ReactComponent as IconAccordionMinimize18 } from "../../icons/icon/18/a-icon-accordeon-minimize-18.svg";
import IconButton from "../button/iconButton";
import TitleRow from "../titleRow/titleRow";

import "./logoGrid.scss";

const LogoGrid = ({
  headline,
  deactivateButtons = false,
  description = "",
  children,
}) => {
  const [showAll, setShowAll] = useState(false);
  const use16Tiles = useMediaQuery("(min-width: 576px) and (max-width: 991px)", true);
  const numberOfChildren = use16Tiles ? 16 : 18;

  return (
    <div className="logo-grid">
      <TitleRow description={description} className="pt-0">{headline}</TitleRow>
      <Row className="logo-grid__partners">
        {
          React.Children.map(
            children,
            (child, index) => (
              (index < numberOfChildren || showAll || deactivateButtons)
                ? <Col xs={4} sm={3} lg={2}>{child}</Col>
                : null
            ),
          )
        }
      </Row>
      {!deactivateButtons && (
        <IconButton
          onClick={() => {
            setShowAll(!showAll);
          }}
          className="logo-grid__button"
          variant="text-primary"
        >
          {showAll
            ? (
              <>
                <FormattedMessage id="hubsection.show_less" />
                <IconAccordionMinimize18 className="ml-12" />
              </>
            )
            : (
              <>
                <FormattedMessage id="hubsection.show_more" />
                <IconAccordionExpand18 className="ml-12" />
              </>
            )}
        </IconButton>
      )}

    </div>
  );
};

LogoGrid.propTypes = {
  children: PropTypes.node.isRequired,
  deactivateButtons: PropTypes.bool,
  description: PropTypes.string,
  headline: PropTypes.string.isRequired,
};

export default LogoGrid;
